//
//
//
//
//
//
//
export default {
  name: 'CoreCustomLogo',
  props: {
    image: {
      type: String,
      required: true
    },
    orientation: {
      type: String,
      required: true
    }
  }
};